import { isStringEmpty } from '../string/is-string-empty.util';
import { ValidatorFunction } from '../../interface/validator-function.type';

export const stringRequiredValidator: (errorMessage: string, messageProps?: string[]) => ValidatorFunction = (errorMessage: string) => (data) => [{
  isValid: !isStringEmpty(data),
  messageKey: errorMessage || 'string.required'
}];